import { getCookies } from '~/store/cookies.js';

const WEB_PUSH_COOKIE_NAME = `webPushPermissionAsked`;
const WEB_PUSH_SAFARI_DEBUG_COOKIE_NAME = `webPushDebugSafari`;
const WEB_PUSH_DISABLED_FOR_AUTOMATED_TESTS_COOKIE_NAME = `webPushDisabledForAutomatedTests`;

// Function to check if the cookie to disable in-house prompt is set or not
const isWebPushDisabledForTests = () => {
	const disableWebPushForTests = getCookies(WEB_PUSH_DISABLED_FOR_AUTOMATED_TESTS_COOKIE_NAME);
	return !!disableWebPushForTests;
};

// function to check wether to show web push permission prompt or not
// Check if permission has already been asked
// The cooldown period is over
// additional logic as to where to show this: TODO
const checkIfCooldown = coolDownInterval => {
	const cookieDateValue = getCookies(WEB_PUSH_COOKIE_NAME);
	if (!cookieDateValue || !coolDownInterval) {
		return true;
	}
	const cookieDate = new Date(cookieDateValue);
	const currentDate = new Date();
	return Math.floor((currentDate - cookieDate) / (24 * 3600 * 1000)) >= parseInt(coolDownInterval, 10);
};

const showPopupPromptCondition = (reduxWebPushPromptEnabled, coolOffPeriod, emarsysUserSubscribed) =>
	reduxWebPushPromptEnabled &&
	checkIfCooldown(coolOffPeriod) &&
	!/iPhone|iPad|iPod/i.test(navigator.userAgent) &&
	!emarsysUserSubscribed &&
	(!/^((?!chrome|android).)*safari/i.test(navigator.userAgent) || getCookies(WEB_PUSH_SAFARI_DEBUG_COOKIE_NAME));

export {
	isWebPushDisabledForTests,
	showPopupPromptCondition,
	WEB_PUSH_SAFARI_DEBUG_COOKIE_NAME,
	WEB_PUSH_COOKIE_NAME,
	WEB_PUSH_DISABLED_FOR_AUTOMATED_TESTS_COOKIE_NAME
};
